import moment from 'moment';
import { months } from './chart';
import { Months } from '../constants/common';

// if date is not passed will return today's date
export const getDateInUiFormat = (date?: Date | string | number | undefined | null) => {
  const d = date ? new Date(date) : new Date();
  return `${d.getDate()} ${months[d.getMonth()]}, ${d.getFullYear()}`;
};

export const formatDate = (timestamp) => {
  var x = new Date(timestamp);
  return moment(x).format('DD/mm/YY');
};
// Get the Date in MM/DD/YYYY format ex Dec 23, 2020
export const getDateinMonthDateYearFormat = (date?: Date | string | number | undefined | null) => {
  const d = date ? new Date(date) : new Date();
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

// To get the next 35 years with a gap of 5 years in between excluding current year in the form ok label, value pair
export const getNext35YearsForPlanSIP = () => {
  let currentYear = new Date().getFullYear();
  let yearsData = [];
  // Below for loop is used if we want to display year with 3 years gap
  // for (let iterator = 3; iterator <= 35; iterator += 3) { 
  // Below for loop is used if we want to display year with 1 years gap
  for (let iterator = 1; iterator <= 35; iterator++) {
    let yearData = {
      label: `${currentYear + iterator}`,
      value: `${currentYear + iterator}`,
    };
    yearsData.push(yearData);
  }
  return yearsData;
};

export const getDateInReadableFormatTransaction = (date: string | undefined | null) => {
  if (!date) {
    return '';
  }
  const splittedDate = date?.split('/');
  if (!splittedDate) {
    return ''; // or whatever default value you want to return
  }
  // 0th index will have date and 2nd index will have year value
  return splittedDate[0] + ` ${months[Number(splittedDate[1]) - 1]}` + `, ${splittedDate[2]}`;
};

export const getDateInSystematicTransaction = (date: string | undefined | null) => {
  const splittedDate = date?.split('-');
  // Fetch only date value and eliminate the timestamp value from the string
  const dateInput = splittedDate[2].substring(0, 2);
  // If the end date has year 2099 consider it as until cancelled to be shown as confirmed from backend team
  if (splittedDate[0] === '2099') {
    return 'Until Cancelled';
  }
  // here 0th index will have year value
  return dateInput + ` ${months[Number(splittedDate[1]) - 1]}` + `, ${splittedDate[0]}`;
};

// Get the todays date in DD/MM/YYYY format
export const getDateinDDMMYYFormat = (dateValue?: Date | string | number | undefined | null) => {
  const today = dateValue ? new Date(dateValue) : new Date();
  let date = String(today.getDate()).padStart(2, '0');
  let month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  let year = today.getFullYear();
  return `${date}/${month}/${year}`;
};

// Get the todays date in DD/MM/YY format
export const getDateinDDMMYYFormatForLast10 = (dateValue?: string | undefined | null) => {
  const today = dateValue ? new Date(dateValue.replace(/\s/, 'T')) : new Date();
  let date = String(today.getDate()).padStart(2, '0');
  let month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  let year = today.getFullYear().toString().substring(2);
  return `${date}/${month}/${year}`;
};

// Get the date of the past 90th day from today's date
export const getPrevious90thDate = () => {
  let today = new Date();
  let priorDate = new Date().setDate(today.getDate() - 90);
  return getDateinDDMMYYFormat(priorDate);
};

export const getDateOrdinal = (date) => {
  if (Number(date) === 1 || Number(date) === 21 || Number(date) === 31) {
    return `${date}st`;
  } else if (Number(date) === 2 || Number(date) === 22) {
    return `${date}nd`;
  } else if (Number(date) === 3 || Number(date) === 23) {
    return `${date}rd`;
  } else {
    return `${date}th`;
  }
};

export const getDateAsPerScheduleDateFormat = (date: any) => {
  const dateInput = new Date(date);
  return getDateOrdinal(dateInput.getDate()) + ' of ' + Months[dateInput.getMonth()];
};

export const isSystematicTransactionCancellationAllowed = (executionDate: any) => {
  const splittedDate = executionDate.split('-');
  const executionDay = splittedDate[2].substring(0, 2); // Remove unncessary timestamp string from date
  const executionMonth = splittedDate[1];
  const executionYear = splittedDate[0];
  const today = new Date();
  let date = String(today.getDate()).padStart(2, '0');
  let month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  let year = String(today.getFullYear());
  // If the execution date is same as today's date and if user clicks on stop button then he shouldn't be
  // able to perform the cancellation of transaction.
  const isCancelAllowed = !(executionDay === date && executionMonth === month && executionYear === year);
  return isCancelAllowed;
};

export const calculateDiffInDays = (minDate: string, maxDate: string) => {
  return new Date(new Date(maxDate).getTime() - new Date(minDate).getTime()).getTime() / (1000 * 3600 * 24);
};

export const uiDateFormat = (date: string | Date) => {
  return moment(date).format('yyyy-MM-DDTHH:mm:ss.SSS');
};
